import { Suspense, lazy } from 'react';
import type { TabLabEChartsProps } from './tab-lab-echarts';
import { Skeleton } from '../../components/ui/skeleton';

const TabLabECharts = lazy(() => import('./tab-lab-echarts').then(mod => ({ 
  default: mod.TabLabECharts 
})));

export function LazyTabLabECharts(props: TabLabEChartsProps) {
  return (
    <Suspense fallback={<Skeleton className="w-full h-full min-h-[200px]" />}>
      <TabLabECharts {...props} />
    </Suspense>
  );
} 